import axios from 'axios';
import Util from '../Util'

class DailyViewAPI {

    constructor() {
        this.apiHost = process.env.VUE_APP_API_HOST;
    }

    getData(dt){

        let path = "/reports/dailyview";

        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));
        endpoint = Util.buildParamUrl(endpoint, { date: dt });

        return axios.get(endpoint).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }

}

let _api = new DailyViewAPI();

export default _api;
